module.exports = __webpack_public_path__ + "static/media/leftlg.fdba5437.png";